type EventType =
  | 'setSideBarItemClick'
  | 'renderTitle'
  | 'companyLogoSrc'
  | 'sideBarIsOpen';

type Subscriptions = {
  [key in EventType]: any;
};

const subscriptions = {} as Subscriptions;

const unSubscribe = (eventType: EventType) => {
  delete subscriptions[eventType];
};

const subscribe = (
  eventType: EventType,
  callback: ({ value }: any) => void | React.ReactNode | string,
) => {
  if (!subscriptions[eventType]) {
    subscriptions[eventType] = {};
  }

  subscriptions[eventType] = callback;

  return () => {
    unSubscribe(eventType);
  };
};

const publish = (eventType: EventType, arg: any) => {
  if (!subscriptions[eventType]) {
    return;
  }

  subscriptions[eventType](arg);
};

export default {
  publish,
  subscribe,
};
